import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Element, scroller } from 'react-scroll';
import HomePage from './Home';
import AboutPage from './About';
import Vision from './Vision';
import Mission from './Mission';
import Services from './Services';

const LandingPage: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === '/home') {
            scroller.scrollTo('home-section', {
                duration: 800,
                delay: 0,
                smooth: 'easeInOutQuart',
            });
        } else if (location.pathname === '/about') {
            scroller.scrollTo('about-section', {
                duration: 800,
                delay: 0,
                smooth: 'easeInOutQuart',
            });
        } else if (location.pathname === '/vision') {
            scroller.scrollTo('vision-section', {
                duration: 800,
                delay: 0,
                smooth: 'easeInOutQuart',
            });
        } else if (location.pathname === '/mission') {
            scroller.scrollTo('mission-section', {
                duration: 800,
                delay: 0,
                smooth: 'easeInOutQuart',
            });
        } else if (location.pathname === '/services') {
            scroller.scrollTo('services-section', {
                duration: 800,
                delay: 0,
                smooth: 'easeInOutQuart',
            });
        }
    }, [location]);

    return (
        <>
            <Element name="home-section">
                <HomePage />
            </Element>
            <Element name="about-section">
                <AboutPage />
            </Element>
            <Element name="vision-section">
                <Vision />
            </Element>
            <Element name="mission-section">
                <Mission />
            </Element>
            <Element name="services-section">
                <Services />
            </Element>
        </>
    );
};

export default LandingPage;